import { render } from "./InstructionMobile.vue?vue&type=template&id=3aa256b9"
import script from "./InstructionMobile.vue?vue&type=script&lang=js"
export * from "./InstructionMobile.vue?vue&type=script&lang=js"

import "./InstructionMobile.vue?vue&type=style&index=0&id=3aa256b9&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__